<template>
  <div
    class="collection-info-section project-3d"
    :class="{'--open': isOpen}"
  >
    <div
      class="collection-info-section__head"
      @click="changeOpen"
    >
      <span class="h5 semibold">3D проект бесплатно</span>
      <img src="../../../assets/img/svg/common/arrow-down.svg" alt="" />
    </div>

    <div class="collection-info-section__body">
      <div class="project-3d__content">
        <div class="--items">
          <template
            v-for="(project) in listItems"
            :key="`project3d-${project.id}`"
          >
            <Project3dCard :project="project"/>
          </template>
          <div class="free-project-link">
            <div @click="openPopUp3dProject">Заказать 3Д проект бесплатно</div>
          </div>
        </div>
        <div class="--button">
          <div
            v-if="isVisibleMoreButton"
            class="project-3d__button-more"
            :class="{'--open': isMoreOpen}"
            @click="changeMoreOpen"
          >
            <img src="~/assets/img/svg/common/arrow-down.svg" alt=""/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { type ComputedRef, ref } from 'vue';
import { useCreateOrder3dProject } from '~/composables/useCreateOrder3dProject';
import Project3dCard from '~/components/collection/3d-project/Project3dCard.vue';
import { useRoute } from '#imports';

export type Project3dListType = {
	created_at: number;
	created_by?: number;
	id: number;
	image_id: number;
	images: Array<{
		caption: string;
		imageId: number;
	}>;
	meta_description?: string;
	meta_keywords?: string;
	meta_title?: string;
	slug: string;
	sort?: number;
	status?: number;
  text: Array<{
    html?: string;
    image_id?: number;
  }>;
	title: string;
	updated_at: number;
	updated_by?: number;
	url: string;
  products?: any[];
}

const props = defineProps<{
	productId: number;
}>();

const $route = useRoute();
const { $api } = useNuxtApp();
const {
  data: btn3dList,
  error,
  execute
} = await useLazyAsyncData<Project3dListType[]>(`${props.productId || 'get'}-3d-project`, async () => await $api.agent
  .get(`projects?filter[product_id]=${props.productId}&sort=-created_at`)
  .then((res) => res._data), { immediate: false });

const { openCreateOrder3dProjectOpen } = useCreateOrder3dProject();

const isOpen = ref(true);

const changeOpen = () => { isOpen.value = !isOpen.value; };
const openPopUp3dProject = () => {
  openCreateOrder3dProjectOpen();
};

async function get3dProjectList () {
  await execute();
  if (error.value) {
    console.log('3dPoject has same error:', error.value);
  }
}

await get3dProjectList();


const isMoreOpen: Ref<boolean> = ref(false);
const listItems: ComputedRef<Project3dListType[]> = computed(() => {
  const _items = [...(btn3dList.value || [])];
  if (!isMoreOpen.value) {
    return _items.splice(0, 1);
  }
  return _items
});
const isVisibleMoreButton: ComputedRef<boolean> = computed(() => {
  return Boolean([...(btn3dList.value || [])].length > 1)
});
const changeMoreOpen = () => {
  isMoreOpen.value = !isMoreOpen.value;
};

</script>

<style lang="scss" scoped>
.project-3d__content {
  display: flex;
  gap: 18px;

  & > .--items {
    display: flex;
    flex-direction: column;
    gap: 16px;
    flex: 1;
  }
  & > .--button {
    width: 56px;
  }
}

.project-3d {
	& .project-card__wrapper {
		display: flex;
		flex-direction: column;
		gap: 16px;
	}
}
.free-project-link {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	padding-bottom: 2px;

	div {
		color: #404040;
		font-size: 16px;
		font-weight: 500;
		line-height: 100%;
		transition: all 0.3s;
		border-bottom: 1px solid #404040;
		cursor: pointer;

		&:hover {
			border-color: transparent;
		}
	}
}

.project-3d__button-more {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border: 1px solid #F4F3F1;
  cursor: pointer;
  border-radius: 14px;
  position: sticky;
  top: 132px;

  &:hover {
    border-color: #404040;
  }

  img {
    width: 32px;
    filter: invert(69%) sepia(5%) saturate(23%) hue-rotate(357deg) brightness(89%) contrast(82%);
  }
  &.--open img {
    transform: rotate(180deg);
  }
}
</style>
